// NPM
import React, { useState, useEffect } from 'react';
import _ from 'lodash';

// State
import { useSelector } from 'react-redux';

// Services
import embedService from 'services/embedService';

// Constants
const rowsToShow = 10;

function RidingProjectionsTable(props) {
  const parties = useSelector(state => state.parties.value);
  const [showingAll, setShowingAll] = useState(false);
  const campaignConfig = useSelector(state => state.campaignConfig.value);

  useEffect(embedService.postHeight, [showingAll]);

  const renderParty = (ridingProjectionIndex, partyId) => {
    const party = parties.find(p => p.id === partyId);

    return (
      <span 
        key={ `RidingProjectionsTable__row-${ ridingProjectionIndex }-prediction-${ partyId }` }
        className="RidingProjectionsTable__prediction"
        style={ {color: party.color} }>
          { party.short }
      </span>
    )
  }

  const renderRidingProjectionRow = (ridingProjection, ridingProjectionIndex) => {
    return (
      <tr 
        key={ `RidingProjectionsTable__row-${ ridingProjectionIndex }`}
        className="RidingProjectionsTable__row">
          <td>{ ridingProjection.riding_name }</td>
          <td>
            { 
              ridingProjection
                .prediction
                .split("/")
                .map(prediction => renderParty(ridingProjectionIndex, prediction)) 
            }
          </td>
          <td>{ ridingProjection.confidence }</td>
      </tr>
    )
  }

  if(_.isBlank(parties)) {
    return null;
  }

  const visibleRidingProjections = props.ridingProjections.slice(0, showingAll ? props.ridingProjections.length : rowsToShow);
  const showAllText = _.get(campaignConfig, "sections.RidingProjections.showAllText");
  const showLessText = _.get(campaignConfig, "sections.RidingProjections.showLessText");

  return (
    <React.Fragment>
      <table className="Signal__section-visualization RidingProjectionsTable">
        <thead>
          <tr>
            <th>Riding Name</th>
            <th>Prediction</th>
            <th>Confidence</th>
          </tr>
        </thead>
        <tbody>
          { visibleRidingProjections.map(renderRidingProjectionRow) }
        </tbody>
      </table>
      <div className="ShowMore">
        <button
          className="button is-rounded"
          onClick={ () => setShowingAll(!showingAll) }>
            { showingAll ? showLessText : showAllText }
        </button>
      </div>
    </React.Fragment>
  )

}

export default RidingProjectionsTable;